import {WhiteColumn} from "../purchasing/WhiteColumn";
import {SectionHeader} from "../../../misc/SectionHeader";
import React, {useEffect, useState} from "react";
import {SmallSearchBox} from "../purchasing/SmallSearchBox";
import {BoolCol, NumberCol, StringCol, Table, ViewOnly} from "../../../misc/scroller/Table";
import { DriverRoute} from "../../../api/Logistics";
import {removeRowOption, RowOptionCol} from "../purchasing/RowOptions";
import {api} from "../../../api/API";
import {CreateRoute} from "./CreateRoute";
import {useNavigate} from "react-router-dom";
import { Container } from "../../../misc/Container";
import {PopoutInteractor} from "../../../misc/PopoutInteractor";
import {ToMoveProps} from "./ToMove";
import {Grid} from "@mui/material";
import {SmallGreyButton} from "../../../misc/SmallGreyButton";
import {OpenInNew} from "@mui/icons-material";
import {RouteViewSelector} from "./weekPlanner/RouteViewSelector";
import {getAll} from "./useGetAll";
import {PageTitle} from "../../../misc/PageTitle";
import {DateFilterCol} from "../../../misc/DateFilterForCol";

export const routeListTableName = "routes.list"
export const routePopupPanel = new PopoutInteractor<ToMoveProps | "refresh-to-move", "refresh-route">("routing.to-move", "/logistics/routes/to-move-popout");

export function RouteList() {
    const [search, setSearch] = useState("")
    const nav = useNavigate();

    useEffect(() => {
        routePopupPanel.sendToClient({});
        return () => routePopupPanel.close();
    }, [])

    return (
        <Container>
            <WhiteColumn>
                <PageTitle title={"Routes"} />
                <SectionHeader name={
                    <Grid container spacing={1} alignItems="center">
                        <Grid item>
                            Routes
                        </Grid>
                        <RouteViewSelector value={"list"} />
                    </Grid>
                }
                               right={
                    <Grid container spacing={1} flexWrap="nowrap">
                        <Grid item>
                            <SmallGreyButton onClick={() => routePopupPanel.open()} startIcon={<OpenInNew />}>
                                To Pickup/Deliver
                            </SmallGreyButton>
                        </Grid>
                        <Grid item>
                            <SmallSearchBox value={search} onChange={setSearch} fullWidth />
                        </Grid>
                    </Grid>
                } />

                <Table<DriverRoute>
                    name={routeListTableName}
                    columns={[
                        RowOptionCol({
                            options: (dt) => [
                                removeRowOption(dt, {
                                    refreshTables: [routeListTableName],
                                    confirm: true,
                                })
                            ],
                        }),
                        ViewOnly(NumberCol("#", "id", 80)),
                        DateFilterCol<DriverRoute>("Date", "date", "ddd, MMM D", 100, "both"),
                        StringCol("Label", "label", 80),
                        ViewOnly(BoolCol("Completed", "completed", 250)),
                    ]}
                    fetch={ctx => getAll(ctx, offset => api.logistics.listRoutes({
                        offset,
                        search,
                    }))}
                    onChange={input => api.logistics.updateRoute(input)}
                    fetchDeps={[search]}
                    onRowClick={item => {
                        nav("/logistics/route/" + item.id)
                    }}
                    insert={{
                        modal: (onDone) => <CreateRoute onDone={onDone} />,
                    }}
                />
            </WhiteColumn>
        </Container>
    )
}
